import { Arg, Metadata } from '../../../../utils/spds/metadata';
import FlexColumn from '../../layout/flex/column.gjs';
import Super from '../../core/base.gjs';
import styles from './body.module.scss';

export const ALIGN_ITEMS_DEFAULT = 'flex-start';
export const ALIGN_SELF_DEFAULT = 'stretch';

const METADATA = Metadata.define({
  description: 'Body for standard modal.',
  meta: {
    titleId: Arg.string({
      description:
        'Id for the modal title when it is rendered in the body (e.g. announcement media); unused by default body chrome.',
    }),
  },
  name: 'Body',
});

export default class SpdsModalStandardBody extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-standard-body';
  styles = styles;

  get alignItems() {
    return this.args.alignItems ?? ALIGN_ITEMS_DEFAULT;
  }

  get alignSelf() {
    return this.args.alignSelf ?? ALIGN_SELF_DEFAULT;
  }

  <template>
    <FlexColumn
      @alignItems={{this.alignItems}}
      @alignSelf={{this.alignSelf}}
      id={{this.id}}
      class={{this.classes}}
      data-test-spds-modal-standard-body
      ...attributes
    >
      {{yield}}
    </FlexColumn>
  </template>
}
